import { AsyncPipe } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { provideTranslocoScope, TranslocoPipe } from '@jsverse/transloco';
import { NzBadgeComponent } from 'ng-zorro-antd/badge';
import { CatalogBadgeService } from './catalog-badge.service';

/** The tabs of the module «Композитные продукты»: the cards, the sections of the site, the labels, the products without a card. */
@Component({
  selector: 'hc-catalog-tabs',
  templateUrl: './catalog-tabs.component.html',
  styleUrls: ['./catalog-tabs.component.less'],
  providers: [provideTranslocoScope('composite-products')],
  imports: [AsyncPipe, RouterLink, RouterLinkActive, TranslocoPipe, NzBadgeComponent]
})
export class CatalogTabsComponent implements OnInit {
  protected readonly badge = inject(CatalogBadgeService);
  protected readonly cardsLink = {paths: 'exact', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored'} as const;

  ngOnInit(): void {
    void this.badge.refresh();
  }
}
